import React, { useEffect, useState } from "react";

// LISA Models

// LISA helpers

// Fluent UI v9
import {
  Button,
  Combobox,
  ComboboxProps,
  Option,
  Tooltip,
} from "@fluentui/react-components";

import { Dismiss24Regular } from "@fluentui/react-icons";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import { IAppUserDto } from "../Models/IAppUserDto";
import LuebPersona from "./LuebPersona";

interface ILuebPersonaPickerProps {
  users: IAppUserDto[];
  selectedUsers: IAppUserDto[];
  disabled?: boolean;
  multiSelect?: boolean;
  showPicture?: boolean;
  onSelectSamAccountName(userID: string): void;
  onRemoveSamAccountName(userID: string): void;
}

function LuebPersonaPicker(props: ILuebPersonaPickerProps) {
  const [matchingUsers, setMatchingUsers] = React.useState<IAppUserDto[]>([]);

  useEffect(() => {
    setMatchingUsers(props.users);
  }, [props.users]);

  return (
    <div style={{ width: "100%" }}>
      {!props.disabled && (
        <Combobox
          positioning="after"
          placeholder="Person auswählen"
          onChange={(e) => {
            const value = e.target.value.trim();
            const matches = props.users.filter((matchingUser) =>
              matchingUser.fullName.toLowerCase().includes(value.toLowerCase()),
            );
            setMatchingUsers(matches);
          }}
          disabled={props.disabled ? props.disabled : false}
          selectedOptions={
            props.selectedUsers &&
            props.selectedUsers.map((user: IAppUserDto) => {
              return user.id;
            })
          }
          multiselect={props.multiSelect ? props.multiSelect : false}
          onOptionSelect={(ev, data) => {
            if (data && data.optionValue) {
              if (
                props.selectedUsers.find((x) => x.id == data.optionValue) !=
                undefined
              ) {
                props.onRemoveSamAccountName(data.optionValue);
              } else {
                props.onSelectSamAccountName(data.optionValue);
              }

              setMatchingUsers(props.users);
            }
          }}
        >
          {matchingUsers.map((user: IAppUserDto) => {
            return (
              <Option text={user.fullName} value={user.id}>
                {(props.showPicture == undefined ||
                  props.showPicture == true) && (
                  <LuebPersona
                    user={user}
                    asAvatar={false}
                    hideTooltip={true}
                  />
                )}
                {props.showPicture == false && user.fullName}
              </Option>
            );
          })}
        </Combobox>
      )}

      <div style={{ marginTop: 10 }}>
        <StackShim horizontal wrap tokens={{ childrenGap: 5 }}>
          {props.selectedUsers.map((user: IAppUserDto) => {
            return (
              <StackShim horizontal tokens={{ childrenGap: 12 }}>
                <LuebPersona user={user} asAvatar={false} hideTooltip={false} />
                {!props.disabled && (
                  <Tooltip content="Benutzer entfernen" relationship="label">
                    <Button
                      icon={<Dismiss24Regular />}
                      onClick={() => {
                        props.onRemoveSamAccountName(user.id);
                      }}
                    />
                  </Tooltip>
                )}
              </StackShim>
            );
          })}
        </StackShim>
      </div>
    </div>
  );
}

export default LuebPersonaPicker;
